import { render, staticRenderFns } from "./bindFlowApp.vue?vue&type=template&id=2e82981c"
import script from "./bindFlowApp.vue?vue&type=script&lang=js"
export * from "./bindFlowApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports